import { render, staticRenderFns } from "./MasonryCollection.vue?vue&type=template&id=303aad4c"
import script from "./MasonryCollection.vue?vue&type=script&lang=js"
export * from "./MasonryCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports